import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Box, Typography, Chip, Paper } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import CategoryIcon from '@mui/icons-material/Category';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" sx={{ color: '#1976d2' }} />;

// Modern stil tanımları
const styles = {
  autocomplete: {
    marginTop: '12px',
    marginBottom: '12px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: '#f8fafc',
      },
      '&.Mui-focused': {
        backgroundColor: '#ffffff',
        boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.1)',
      },
    },
    '& .MuiInputLabel-root': {
      fontWeight: 500,
      color: '#64748b',
      '&.Mui-focused': {
        color: '#1976d2',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e2e8f0',
    },
  },
  listbox: {
    padding: '8px',
    '& .MuiAutocomplete-option': {
      borderRadius: '8px',
      margin: '2px 0',
      padding: '8px 12px',
    },
  },
  optionContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  optionLabel: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: '#334155',
  },
  hizmetChip: {
    borderRadius: '8px',
    fontWeight: 500,
    backgroundColor: '#dbeafe',
    color: '#1d4ed8',
    border: '1px solid #bfdbfe',
    '& .MuiChip-deleteIcon': {
      color: '#1d4ed8',
      '&:hover': {
        color: '#1e40af',
      },
    },
  },
  iscilikChip: {
    borderRadius: '8px',
    fontWeight: 500,
    backgroundColor: '#fef3c7',
    color: '#b45309',
    border: '1px solid #fde68a',
    '& .MuiChip-deleteIcon': {
      color: '#b45309',
      '&:hover': {
        color: '#92400e',
      },
    },
  },
  paper: {
    borderRadius: '12px',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e2e8f0',
    marginTop: '4px',
  },
};

export default function MultipleSelectAutocomplete({
  data,
  type,
  selectedValues,
  onChange
}) {
  const isHizmetler = type === 'Hizmetler' || type === 'hizmetler';
  
  const handleChange = (event, value) => {
    if (Array.isArray(value)) {
      onChange(value.map(option => ({ Id: option.Id })));
    } else if (value) {
      onChange([{ Id: value.Id }]);
    } else {
      onChange([]);
    }
  };

  return (
    <Autocomplete
      multiple={type !== 'hizmetler'}
      id="MultipleSelectAutocomplete"
      options={data}
      disableCloseOnSelect
      fullWidth
      sx={styles.autocomplete}
      ListboxProps={{
        sx: styles.listbox,
      }}
      PaperComponent={({ children }) => (
        <Paper sx={styles.paper}>{children}</Paper>
      )}
      getOptionLabel={option => option.Dsc}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={option.Id} {...optionProps}>
            <Box sx={styles.optionContent}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={selected}
                sx={{ padding: '4px' }}
              />
              <Typography sx={styles.optionLabel}>
                {option.Dsc}
              </Typography>
            </Box>
          </li>
        );
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.Id}
            label={option.Dsc}
            size="small"
            icon={isHizmetler ? 
              <CategoryIcon sx={{ fontSize: '14px !important' }} /> : 
              <BuildIcon sx={{ fontSize: '14px !important' }} />
            }
            sx={isHizmetler ? styles.hizmetChip : styles.iscilikChip}
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          label={isHizmetler ? 'Hizmetler' : 'İşçilikler'}
          placeholder={isHizmetler ? 'Hizmet seçiniz...' : 'İşçilik seçiniz...'}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {isHizmetler ? (
                  <CategoryIcon sx={{ color: '#94a3b8', marginLeft: '8px', marginRight: '-4px' }} />
                ) : (
                  <BuildIcon sx={{ color: '#94a3b8', marginLeft: '8px', marginRight: '-4px' }} />
                )}
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      noOptionsText={
        <Box sx={{ padding: '16px', textAlign: 'center' }}>
          <Typography sx={{ color: '#94a3b8', fontSize: '0.875rem' }}>
            {isHizmetler ? 'Hizmet bulunamadı' : 'İşçilik bulunamadı'}
          </Typography>
        </Box>
      }
      onChange={handleChange}
    />
  );
}
